/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-edit-buttons",
  templateUrl: "./edit-buttons.component.html"
})
export class EditButtonsComponent {
  faTrash = faTrashAlt;
  faEditPencil = faEdit;
  @Input() buttonName!: string;
  @Input() actionInProgress = false;
  @Input() formInvalid = false;
  @Output() editableEvent = new EventEmitter<boolean>();

  setEditable(value: boolean) {
    this.editableEvent.emit(value);
  }
}
